<template>
  <div class="truck-sighting slide">
    <VerticalAnimation :animation="animation" :background="background" :loop="true" />
    <div class="vertical-layout animated fadeIn delay-2s">
      <h1>Pawn Shop</h1>
      <p>After 5 days of mobile surveillance, API and LE teams observe the cargo van visit several THD locations and make multiple trips to a local pawn shop. Investigators decide to conduct 2 days of static surveillance of this pawn shop.</p>
    </div>
    <router-link to="/orange-pickup">
      <NextButton />
    </router-link>
  </div>
</template>

<script>
import VerticalAnimation from '@/components/VerticalAnimation.vue'
import NextButton from '@/components/NextButton.vue'
import PawnShop from '@/assets/pawn-shop.js'
import VerticalImage from '@/assets/pawn-shop-bg@2x.png'

export default {
  name: 'truck-sighting',
  components: {
    VerticalAnimation,
    NextButton
  },
  data() {
    return {
      animation: PawnShop,
      background: VerticalImage
    }
  },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>
  .vertical-layout {
    top: 36%
  }
  h1 {
    margin-bottom: 0;
  }
  p {
    margin-top: 10px;
  }
</style>
